/*
 * pgc-fit-taste-notes — keeps product-card taste notes within 2 lines.
 * The .card__taste-notes box is clamped to 2 lines in CSS; this shrinks the
 * font just enough that the full text fits those 2 lines instead of being
 * truncated with an ellipsis. Runs on load, on resize, and when a product
 * grid re-renders (e.g. collection filtering).
 */
(function () {
  var MIN_PX = 8;

  function fit(el) {
    el.style.fontSize = ''; // reset to the CSS base each pass
    var size = parseFloat(getComputedStyle(el).fontSize);
    var guard = 0;
    while (el.scrollHeight > el.clientHeight + 1 && size > MIN_PX && guard < 24) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
      guard++;
    }
  }

  function run(root) {
    (root || document).querySelectorAll('.card__taste-notes').forEach(fit);
  }

  function init() {
    run();
    document.querySelectorAll('#product-grid, .product-grid').forEach(function (grid) {
      var d;
      new MutationObserver(function () {
        clearTimeout(d);
        d = setTimeout(function () { run(grid); }, 60);
      }).observe(grid, { childList: true, subtree: true });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () { run(); }, 150);
  });
})();
